tinymce.Resource.add('tinymce.html-i18n.help-keynav.it',
'<h1>Iniziare la navigazione tramite tastiera</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Impostare lo stato attivo per la barra dei menu</dt>\n' +
  '  <dd>Windows o Linux: ALT+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>Impostare lo stato attivo per la barra degli strumenti</dt>\n' +
  '  <dd>Windows o Linux: ALT+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Impostare lo stato attivo per il piè di pagina</dt>\n' +
  '  <dd>Windows o Linux: ALT+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Metti a fuoco la notifica</dt>\n' +
  '  <dd>Windows o Linux: ALT+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>Impostare lo stato attivo per la barra degli strumenti contestuale</dt>\n' +
  '  <dd>Windows, Linux o macOS: CTRL+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  "<p>La navigazione inizierà dalla prima voce dell'interfaccia utente, che sarà evidenziata o sottolineata nel caso della prima voce\n" +
  "  nel percorso dell'elemento del piè di pagina.</p>\n" +
  '\n' +
  "<h1>Navigare tra le sezioni dell'interfaccia utente</h1>\n" +
  '\n' +
  "<p>Per passare da una sezione dell'interfaccia utente alla successiva, premere <strong>TAB</strong>.</p>\n" +
  '\n' +
  "<p>Per passare da una sezione dell'interfaccia utente alla precedente, premere <strong>MAIUSC+TAB</strong>.</p>\n" +
  '\n' +
  "<p>L'ordine di <strong>tabulazione</strong> di queste sezioni dell'interfaccia utente è:</p>\n" +
  '\n' +
  '<ol>\n' +
  '  <li>Barra dei menu</li>\n' +
  '  <li>Ogni gruppo di barre degli strumenti</li>\n' +
  '  <li>Barra laterale</li>\n' +
  "  <li>Percorso dell'elemento nel piè di pagina</li>\n" +
  '  <li>Pulsante di attivazione/disattivazione del conteggio delle parole nel piè di pagina</li>\n' +
  '  <li>Collegamento al marchio nel piè di pagina</li>\n' +
  "  <li>Quadratino di ridimensionamento dell'editor nel piè di pagina</li>\n" +
  '</ol>\n' +
  '\n' +
  "<p>Se una sezione dell'interfaccia utente non è presente, viene saltata.</p>\n" +
  '\n' +
  '<p>Se il piè di pagina ha lo stato attivo per la navigazione tramite tastiera e non è presente alcuna barra laterale visibile, premendo <strong>MAIUSC+TAB</strong>\n' +
  "  si sposta lo stato attivo sul primo gruppo di barre degli strumenti, non sull'ultimo.</p>\n" +
  '\n' +
  "<h1>Navigare all'interno delle sezioni dell'interfaccia utente</h1>\n" +
  '\n' +
  "<p>Per passare da un elemento dell'interfaccia utente al successivo, premere il tasto <strong>freccia</strong> appropriato.</p>\n" +
  '\n' +
  '<p>I tasti freccia <strong>Sinistra</strong> e <strong>Destra</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>consentono di spostarsi tra i menu della barra dei menu.</li>\n' +
  '  <li>aprono un sottomenu in un menu.</li>\n' +
  '  <li>consentono di spostarsi tra i pulsanti di un gruppo di barre degli strumenti.</li>\n' +
  "  <li>consentono di spostarsi tra le voci nel percorso dell'elemento del piè di pagina.</li>\n" +
  '</ul>\n' +
  '\n' +
  '<p>I tasti freccia <strong>Giù</strong> e <strong>Su</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>consentono di spostarsi tra le voci di un menu.</li>\n' +
  '  <li>consentono di spostarsi tra le voci di un menu a comparsa della barra degli strumenti.</li>\n' +
  '</ul>\n' +
  '\n' +
  "<p>I tasti <strong>freccia</strong> consentono di spostarsi all'interno della sezione dell'interfaccia utente con stato attivo.</p>\n" +
  '\n' +
  '<p>Per chiudere un menu aperto, un sottomenu aperto o un menu a comparsa aperto, premere il tasto <strong>ESC</strong>.</p>\n' +
  '\n' +
  "<p>Se lo stato attivo corrente si trova nella parte superiore di una particolare sezione dell'interfaccia utente, premendo il tasto <strong>ESC</strong> si esce\n" +
  '  completamente dalla navigazione tramite tastiera.</p>\n' +
  '\n' +
  '<h1>Eseguire una voce di menu o un pulsante della barra degli strumenti</h1>\n' +
  '\n' +
  '<p>Quando la voce di menu o il pulsante della barra degli strumenti desiderati sono evidenziati, premere il tasto di<strong>ritorno a capo</strong>, il tasto <strong>Invio</strong>\n' +
  '  o la <strong>barra spaziatrice</strong> per eseguirli.</p>\n' +
  '\n' +
  '<h1>Navigare nelle finestre di dialogo non a schede</h1>\n' +
  '\n' +
  "<p>Nelle finestre di dialogo non a schede, all'apertura della finestra di dialogo diventa attivo il primo componente interattivo.</p>\n" +
  '\n' +
  '<p>Per spostarsi tra i componenti interattivi della finestra di dialogo, premere <strong>TAB</strong> o <strong>MAIUSC+TAB</strong>.</p>\n' +
  '\n' +
  '<h1>Navigare nelle finestre di dialogo a schede</h1>\n' +
  '\n' +
  "<p>Nelle finestre di dialogo a schede, all'apertura della finestra di dialogo diventa attivo il primo pulsante del menu della scheda.</p>\n" +
  '\n' +
  '<p>Per spostarsi tra i componenti interattivi di questa scheda della finestra di dialogo, premere <strong>TAB</strong> o\n' +
  '  <strong>MAIUSC+TAB</strong>.</p>\n' +
  '\n' +
  "<p>Per passare a un'altra scheda della finestra di dialogo, attivare il menu della scheda e premere il tasto <strong>freccia</strong>\n" +
  '  appropriato per scorrere le schede disponibili.</p>\n');